import { createFileRoute } from '@tanstack/react-router'
import { PipelineFleetPage } from 'pages/pipelineFleet/PipelineFleetPage'

export const Route = createFileRoute('/pipeline-fleet/')({
  component: PipelineFleetPage,
  staticData: {
    title: 'Pipeline Fleet',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
      hideSiteSelector: true,
    },
  },
})
